import { Source } from '../types';

export const SOURCES_DATA: Source[] = [
  {
    key: 'redditConnected',
    name: 'Reddit',
    path: 'reddit',
    icon: 'fab fa-reddit',
    color: '#ff4500',
    disabled: false,
  },
  {
    key: 'twitchConnected',
    name: 'Twitch',
    path: 'twitch',
    icon: 'fab fa-twitch',
    color: '#ac70ff',
    disabled: false,
  },
  {
    key: 'githubConnected',
    name: 'GitHub',
    path: 'github',
    icon: 'fab fa-github',
    color: '#fff',
    disabled: false,
  },
  {
    key: 'youtubeConnected',
    name: 'YouTube',
    path: 'youtube',
    icon: 'fab fa-youtube',
    color: '#ff0000',
    disabled: false,
  },
  {
    key: 'steamId',
    name: 'Steam',
    path: 'steam',
    icon: 'fab fa-steam',
    color: '#c7c2bf',
    disabled: false,
  },
  {
    key: 'whatsappConnected',
    name: 'WhatsApp',
    path: 'whatsapp',
    icon: 'fab fa-whatsapp',
    color: '#25d366',
    disabled: false,
    requiresQR: true,
  },
  {
    key: 'stackexchangeConnected',
    name: 'Stack Overflow',
    path: 'stackexchange',
    icon: 'fa-brands fa-stack-overflow',
    color: '#f57f25',
    disabled: true,
  },
  {
    key: 'etsyConnected',
    name: 'Etsy',
    path: 'etsy',
    icon: 'fab fa-etsy',
    color: '#f2641d',
    disabled: true,
  },
  {
    key: 'snapchatConnected',
    name: 'Snapchat',
    path: 'snapchat',
    icon: 'fab fa-snapchat',
    color: '#fffb00',
    disabled: true,
  },
  {
    key: 'spotifyConnected',
    name: 'Spotify',
    path: 'spotify',
    icon: 'fab fa-spotify',
    color: '#1db954',
    disabled: true,
  },
  {
    key: 'xConnected',
    name: 'X',
    path: 'x',
    icon: 'fab fa-x-twitter',
    color: '#fff',
    disabled: true,
  },

];
